import { render, staticRenderFns } from "./ProductZoomer.vue?vue&type=template&id=38124f7d&scoped=true&"
import script from "./ProductZoomer.vue?vue&type=script&lang=js&"
export * from "./ProductZoomer.vue?vue&type=script&lang=js&"
import style0 from "./ProductZoomer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductZoomer.vue?vue&type=style&index=1&id=38124f7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38124f7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/irvan/ECLIPSE/br-monorepo/js/solvent_js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38124f7d')) {
      api.createRecord('38124f7d', component.options)
    } else {
      api.reload('38124f7d', component.options)
    }
    module.hot.accept("./ProductZoomer.vue?vue&type=template&id=38124f7d&scoped=true&", function () {
      api.rerender('38124f7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/solvent/components/ProductZoomer.vue"
export default component.exports